import React from 'react'
import { connect } from 'react-redux'
import { injectIntl } from 'react-intl'
import mainBackgroundImage from '../../../assets/img/banner-outlet-australia/banner-outlet-australia.png'
import { changeCenter } from '../../../store/centers/actions'
import { getLocalizedUrl } from '../../../store/ui/reducers'

import Translation from '../../global/Translation'
import LocalizedLink from '../../global/LocalizedLink'
import { FormattedHTMLMessage } from 'react-intl'
import Button from '../../global/Button'
import { getSelectedCenter } from '../../../store/centers/reducers'

const mapStateToProps = state => {
    return {
        localizedUrl: (intl, routeId, params = {}) => getLocalizedUrl(state, intl, routeId, params),
        selectedCenter: getSelectedCenter(state)
    }
}

const mapDispatchToProps = dispatch => {
    return {
        onChangeCenter: (centerId, urlCallback) => {
            dispatch({ type: 'CHANGE_CENTER_BY_USER', center: centerId })
            dispatch(changeCenter(centerId, urlCallback))
            dispatch({ type: 'REMEMBERED_CENTER' })
        }
    }
}

class BannerOutletAustralia extends React.Component {
    constructor(props) {
        super(props)

        this.discount = '10%'
    }

    render() {
        const { className, isCheckoutView, isOnlyUsaSalesOrg, isHomeSlideView } = this.props

        const headerContent = (
            <div>
                <h2>
                    <Translation id="super_outlet_promo" defaultMessage="Super Outlet Promo:" />&nbsp;
                </h2>
                <h2>
                    <Translation id="dekton_sensa" defaultMessage="Dekton & Sensa" />
                </h2>
                <h3>
                    <Translation id="unbeatable_prices" defaultMessage="Selected colours only. Unbeatable prices on these outlet slabs." />
                </h3>
            </div>
        )


        return (
            <div>
                <div
                    className="banner_outlet_australia"
                    style={{
                        backgroundImage: `url(${mainBackgroundImage})`,
                        backgroundRepeat: 'no-repeat',
                        backgroundSize: 'cover',
                        height: '100%',
                        width: '100%',
                    }}
                >
                    <div>
                        <div className="banner_outlet_australia--title">{headerContent}</div>
                        <div className="banner_outlet_australia--ad">
                            <Translation id="for_limited_time" defaultMessage="FOR A LIMITED TIME!" />
                        </div>
                    </div>
                    <div className="banner_outlet_australia--cta">
                        <LocalizedLink routeId="ROUTE_CATALOG" queryString="?type[0]=SLAB&brand[0]=SENSA&brand[1]=DEKTON" params={{ outlet: 'outlet' }}>
                            <Button inline className="cta" dataQas="catalog-banner-outlet-australia">
                                <Translation id="view_available_stock" defaultMessage="View Available Stock	" />
                            </Button>
                        </LocalizedLink>
                    </div>
                </div>
            </div>
        )
    }
}

export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(BannerOutletAustralia))
